import ColorTool from "../colors/ColorTool";
import GeomTool from "../geom/GeomTool";
import MathTool from "../math/MathTool";

export default class Bristle{
    constructor( color, size, position, brightVariation=0.5 ){        
        this.color = ColorTool.shiftBrightness( color, MathTool.randInt(brightVariation,-brightVariation) );
        //this.color = ColorTool.shiftSaturation( color, MathTool.randInt(35,-35) );
        this.size = size;
        this.position = position;
        this.brightVariation = brightVariation;
        this.noiseOffset = MathTool.random()*1000000
        //console.log( "Bristle constructor" );
    }

    paint(  ){
        //console.log( "line: ", p0, p1 )
        //p5App.push();
        //p5App.fill( this.color );  
        p5App.circle( this.position.x, this.position.y, this.size );
        //p5App.pop();
        //line( p0.x, p0.y, p1.x, p1.y );
    }
    
    paintGesture( pts ){
        let gesturePoints = pts; //GeomTool.getCurvePoints(pts, null, 50);        
        p5App.push();
        p5App.beginShape();
        p5App.noFill();
        p5App.strokeWeight( this.size );
        p5App.stroke( this.color );
        p5App.translate( this.position.x, this.position.y );
        let pt = gesturePoints[0];
        p5App.curveVertex( pt.x, pt.y );
        for (let i = 0; i < gesturePoints.length; i++) {
            pt = gesturePoints[i];
            p5App.curveVertex( pt.x, pt.y );
        }       
        p5App.curveVertex( pt.x, pt.y );
        p5App.endShape(); 
        p5App.pop();



        /* let gesturePoints = GeomTool.getCurvePoints(pts, null, 50);        
        let ctx = p5App.drawingContext;
        ctx.save();        
        ctx.translate( this.position.x, this.position.y );
        ctx.strokeWidth = ( this.size );
        ctx.strokeStyle = this.color;
        ctx.beginPath();
        ctx.moveTo(gesturePoints[0].x, gesturePoints[0].y);
        
        gesturePoints.forEach(element => {
            ctx.lineTo(element.x, element.y);                    
        });    

        ctx.stroke();
        ctx.restore();
 */
        /////
        /* let gesturePoints = GeomTool.getCurvePoints(pts, null, 50);
        p5App.push();
        p5App.translate( this.position.x, this.position.y );
        p5App.strokeWeight( this.size );
        p5App.stroke( this.color );
        for (let i = 0; i < gesturePoints.length-2; i++) {
            let pt = gesturePoints[i];
            let ptNext = gesturePoints[i+1];
            p5App.line( pt.x, pt.y, ptNext.x, ptNext.y );
        }        
        p5App.pop(); */
    }
}